<script>
  import Modal from "@/core/components/Modal"
  import PdfCertificate from "@/domains/lines/views/schedules/components/PdfCertificate.vue"

  export default {
    components: {
      Modal,
      PdfCertificate,
    },
    props: {
      organization_id: { type: String, default: null },
    },
    data: () => {
      return {
        registryPDF: null,
      }
    },
    watch: {
      closed: function () {
        this.page = 1
      },
    },
    mounted() {
      if (this.organization_id) {
        this.generateRegistryStatement()
      }
    },
    methods: {
      async generateRegistryStatement() {
        try {
          const response = await this.$axios.get(
            "/api/transport/technical-info/" +
              this.organization_id +
              "/registry-statement/false",
            {
              dataType: "binary",
              processData: false,
              responseType: "arraybuffer",
            }
          )
          let blob = new Blob([response["data"]], {
            type: response.headers["content-type"],
          })
          this.registryPDF = {
            url: window.URL.createObjectURL(blob),
          }
          this.$Progress.finish()
        } catch (e) {
          this.registryPDF = null
          this.$Progress.finish()
        }
      },
    },
  }
</script>

<template>
  <div>
    <Modal width="1200" :no-padding="true" :no-margin="true">
      <div slot="body">
        <pdf-certificate :certificate="registryPDF" @close="$emit('close')"/>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>
